import i18next from 'i18next';


// If validator returns empty str -> valid

export function emailValidator(value, errorMessage) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
        return errorMessage || i18next.t("error:emailFieldError");
    }
    return "";
}


export function nameValidator(value, errorMessage) {
    if (!value || value.length < 3) {
        return errorMessage || i18next.t("error:nameFieldError");
    }
    
    // Regular expression that allows letters (including accented characters),
    // spaces, hyphens, and apostrophes
    const nameRegex = /^[\p{L}'\-\s]+$/u;
    
    if (!nameRegex.test(value)) {
        return errorMessage || i18next.t("error:nameContainsInvalidCharacters");
    }
    
    return "";
}

export function notEmptyValidator(value, errorMessage){
    if(!value)
        return errorMessage || i18next.t("error:noValueError");
    return ""
}

// Length In Range Validator Factory
export function createLengthInRangeValidator(minLen, maxLen, errorMessage) {
    return function (value) {
        if (typeof value !== "string" || value.length < minLen || value.length > maxLen) {
            return errorMessage || i18next.t("error:lengthInRangeError", { min: minLen, max: maxLen });
        }
        return "";
    };
}

// Number In Range Validator Factory
export function createNumberInRangeValidator(min, max, errorMessage) {
    return function (value) {
        const num = Number(value);
        if (isNaN(num) || num < min || num > max) {
            return errorMessage || i18next.t("error:numberInRangeError", { min, max });
        }
        return "";
    };
}

// Length Min Validator Factory
export function createLengthMinValidator(minLen, errorMessage) {
    return function (value) {
        if (typeof value !== "string" || value.length < minLen) {
            return errorMessage || i18next.t("error:lengthMinError", { min: minLen });
        }
        return "";
    };
}

// Length Max Validator Factory
export function createLengthMaxValidator(maxLen, errorMessage) {
    return function (value) {
        if (typeof value !== "string" || value.length > maxLen) {
            return errorMessage || i18next.t("error:lengthMaxError", { max: maxLen });
        }
        return "";
    };
}

// Date Before Validator Factory
export function createDateBeforeValidator(getComparedDate, errorMessage) {
    return function (value) {
        if (!value) return "";

        const comparedValue = typeof getComparedDate === "function"
            ? getComparedDate()
            : getComparedDate;
        if (!comparedValue) return "";

        const currentDate = new Date(value);
        const comparedDate = new Date(comparedValue);
        if (isNaN(currentDate.getTime()) || isNaN(comparedDate.getTime())) return "";

        if (currentDate >= comparedDate) {
            return errorMessage || i18next.t("error:challengeStartDateBeforeEndDate");
        }
        return "";
    };
}

// Date After Validator Factory
export function createDateAfterValidator(getComparedDate, errorMessage) {
    return function (value) {
        if (!value) return "";

        const comparedValue = typeof getComparedDate === "function"
            ? getComparedDate()
            : getComparedDate;
        if (!comparedValue) return "";

        const currentDate = new Date(value);
        const comparedDate = new Date(comparedValue);
        if (isNaN(currentDate.getTime()) || isNaN(comparedDate.getTime())) return "";

        if (currentDate <= comparedDate) {
            return errorMessage || i18next.t("error:challengeStartDateBeforeEndDate");
        }
        return "";
    };
}

// Number Min Validator Factory
export function createNumberMinValidator(min, errorMessage) {
    return function (value) {
        const num = Number(value);
        if (isNaN(num) || num < min) {
            return errorMessage || i18next.t("error:numberMinError", { min });
        }
        return "";
    };
}

// Number Max Validator Factory
export function createNumberMaxValidator(max, errorMessage) {
    return function (value) {
        const num = Number(value);
        if (isNaN(num) || num > max) {
            return errorMessage || i18next.t("error:numberMaxError", { max });
        }
        return "";
    };
}
